import { useEffect } from "react"
import QuillEditor from "./quill/QuillEditor.js"


const EditorQuill = ({onChange, event}) => {

    return (
        <QuillEditor content={event.content} onChange={(content) => onChange("content", content)}/>
    )

}

export default EditorQuill